import Cookies from "js-cookie";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const secureFetchBlob = async (url) => {
    url = API_BASE_URL + "/" + url;
    const csrfToken = localStorage.getItem("csrfToken") || Cookies.get("XSRF-TOKEN");
    const authToken = localStorage.getItem("authToken");
  
    const headers = {};
    if (csrfToken) headers["X-CSRF-Token"] = csrfToken;
    if (authToken) headers["Authorization"] = `Bearer ${authToken}`;
  
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers
    });
  
    if (!response.ok) throw new Error("File download failed");
  
    return response;
};

export const secureFetchImageBlobUrl = async (url) => {
  try {
    const response = await secureFetchBlob(url);
    // const contentType = response.headers.get("content-type") || "";

    // if (!contentType.startsWith("image/")) {
    //   throw new Error(`Invalid content-type: ${contentType}`);
    // }

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (err) {
    console.error("Image load error:", err);
    return null;
  }
};